import React, {Component} from "react";
import {Form} from "antd";
import CmSwitch from "../../../../../../components/CmSwitch/CmSwitch";

export default class IsEnable extends Component {
    render() {
        const {
            value,
            onChange
        } = this.props;
        return (
            <CmSwitch
                checkedChildren="开"
                unCheckedChildren="关"
                checked={value}
                onChange={onChange}
            />
        );
    }
}
